import { useRef, useState } from "react";

import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";

export default (props) => {
  const { className = "", style = {}, html = "", imageLightbox = false } =
    props;
  const containerRef = useRef(null);
  const [lightbox, setLightbox] = useState(null);

  // 点击容器内的 <img> 时，收集当前实例的全部图片并打开 lightbox
  const handleContentClick = (e) => {
    if (!imageLightbox) return;
    const img = e.target.closest && e.target.closest("img");
    const container = containerRef.current;
    if (!img || !container || !container.contains(img)) return;
    const imgs = Array.from(container.querySelectorAll("img")).filter(
      (el) => el.currentSrc || el.src
    );
    const index = imgs.indexOf(img);
    if (index < 0) return;
    setLightbox({
      slides: imgs.map((el) => ({ src: el.currentSrc || el.src })),
      index,
    });
  };

  return (
    <div>
      <div
        ref={containerRef}
        style={style}
        className={`rich-content ${className} ${
          imageLightbox ? "rich-content-lightbox" : ""
        }`}
        onClick={handleContentClick}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      {lightbox && (
        <Lightbox
          open
          slides={lightbox.slides}
          index={lightbox.index}
          close={() => setLightbox(null)}
          plugins={[Zoom, Counter]}
          zoom={{ maxZoomPixelRatio: 4, scrollToZoom: true }}
          counter={{ separator: " / " }}
          controller={{
            closeOnBackdropClick: true,
            closeOnPullDown: true,
          }}
          styles={{ container: { backgroundColor: "rgba(0, 0, 0, .9)" } }}
        />
      )}
      <style jsx global>
        {`
          .rich-content p {
            font-size: 16px;
            padding-top: 8px;
            padding-bottom: 8px;
            margin: 0;
            line-height: 26px;
          }
          .rich-content h1,
          .rich-content h2,
          .rich-content h3,
          .rich-content h4,
          .rich-content h5,
          .rich-content h6 {
            margin-top: 30px;
            margin-bottom: 15px;
            font-weight: bold;
          }
          .rich-content ul,
          .rich-content ol {
            margin-top: 8px;
            margin-bottom: 8px;
            padding-left: 25px;
          }

          .rich-content li {
            margin-top: 5px;
            margin-bottom: 5px;
            line-height: 26px;
            text-align: left;
            // font-weight: 500;
            font-weight: 400;
          }
          .rich-content {
            font-family: Optima-Regular, Optima, PingFangSC-light,
              PingFangTC-light, "PingFang SC", Cambria, Cochin, Georgia, Times,
              "Times New Roman";
          }
          .rich-content-lightbox img {
            cursor: zoom-in;
          }
        `}
      </style>
    </div>
  );
};
